// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".advice-card{margin-top:40px}.advice-card .links{list-style:none;padding:0}", "",{"version":3,"sources":["webpack://./src/components/adviceCard/styles.scss"],"names":[],"mappings":"AAAA,aACE,eAAA,CAEA,oBACE,eAAA,CACA,SAAA","sourcesContent":[".advice-card {\n  margin-top: 40px;\n\n  .links {\n    list-style: none;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
